<template>
  <button class="flex flex-col shadow-sm rounded hover:border-gray-600 ml-1 border-box flex-none w-16 h-16 overflow-hidden border border-blue-800 rounded pt-2 focus:outline-none"
          @click='$emit("select", image)'
          :class='isSelected ? "bg-blue-400" : "bg-blue-900"'>
      <img class="object-contain w-full h-16 md:h-16"
           :src='image.url'
           loading="lazy" />
  </button>

</template>
<script>
export default {
  props:{
    image:{
      type:Object,
      required:true
    },
    isSelected:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
    }
  },
  methods:{
    deselect() {
    }
  },
  mounted() {
  },
  watch:{
    isSelected:{
      handler(nv) {
      },
      immediate:true
    }
  }
}
</script>

